import { render } from "./RemoveFromFoodOrder.vue?vue&type=template&id=4f5979f7"
import script from "./RemoveFromFoodOrder.vue?vue&type=script&lang=js"
export * from "./RemoveFromFoodOrder.vue?vue&type=script&lang=js"

import "./RemoveFromFoodOrder.vue?vue&type=style&index=0&id=4f5979f7&lang=css"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__